import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DataGrid from '../../../../../../table/DataGrid';
import Avatar from '../../../../../../avatar/Avatar';
import { Alert, Checkbox } from '@mui/material';
import ButtonStartIcon from '../../../../../../button/ButtonStartIcon';
import InputField from '../../../../../../FormControl/input/InputField';
import { updateStudentsSelectedBulkMarking } from '../../../../../../../store/actions/class-marking.actions';
import { useParams } from 'react-router-dom';
import Loading from '../../../../../../Loading/Loading';

const SelectStudentsTable = () => {
  const dispatch = useDispatch();
  const { ulId } = useParams();
  const totalList = useSelector((state) =>
    JSON.parse(
      JSON.stringify(
        state?.classMarking?.students?.filter(
          (item) => item?.lcs?.filter((l) => l.ulId === ulId)?.length > 0
        ) || []
      )
    )
  );
  const error = useSelector((state) => state?.classMarking?.errorBulk || {});
  const loading = useSelector((state) => state?.classMarking?.studentsLoading);
  const [checkIds, setCheckIds] = useState([]);
  const [list, setList] = useState(totalList);

  const onSelectedAll = (checked) => {
    if (checked) {
      const list = totalList.map((item) => item._id);
      setCheckIds(list);
    } else {
      setCheckIds([]);
    }
  };

  const onSelected = (id, checked) => {
    if (checked) {
      setCheckIds([...checkIds, id]);
    } else {
      setCheckIds(checkIds.filter((item) => item !== id));
    }
  };

  const onSearch = useCallback(
    (value) => {
      const search = value.toLowerCase();
      const newList = totalList.filter((item) => {
        return (
          item?.code.toLowerCase().includes(search) ||
          item?.firstName.toLowerCase().includes(search) ||
          item?.lastName.toLowerCase().includes(search) ||
          item?.preferredName.toLowerCase().includes(search)
        );
      });
      setList(newList);
    },
    [totalList]
  );

  useEffect(() => {
    const liststudents = totalList.filter((item) => checkIds.includes(item._id));
    dispatch(updateStudentsSelectedBulkMarking(liststudents));
  }, [checkIds]);

  useEffect(() => {
    setList(totalList);
  }, [loading]);

  return (
    <>
      <div className='absolute left-0px right-0 top-0 z-2'>
        <div className='flex items-center gap-4 h-16 relative bg-background'>
          <ButtonStartIcon
            variant='text'
            startIcon='bars-filter'
            title='Filter'
            color='primary'
            classNameIcon='text-3xl'
            size='large'
          >
            Filter
          </ButtonStartIcon>
          <div className='max-w-250px'>
            <InputField placeholder='Search' onChange={(e) => onSearch(e.target.value)} disabled={loading} />
          </div>
          {error.message && (
            <Alert severity='error' className='absolute right-0'>
              {error.message}
            </Alert>
          )}
        </div>
      </div>
      <div className='absolute left-0px right-0 bottom-0 top-16 overflow-auto'>
        {loading ? (
          <Loading />
        ) : totalList.length === 0 ? (
          <div className='flex items-center justify-center h-80'>
            <Alert severity='error'>Students do not have information to execute this action</Alert>
          </div>
        ) : (
          <DataGrid
            id='students-marking-classes'
            showSetting={false}
            rows={list.map((item, index) => ({
              ...item,
              index: index + 1,
              fullName: `${item?.preferredName || item?.firstName} ${item?.lastName}`,
              avatar: (
                <div className='flex items-center justify-center'>
                  <Avatar size='small' variant='circular' alt={item?.code} src={`photos/${item?.photo}`} />
                </div>
              ),
              checkIds: (
                <Checkbox
                  id={`checkbox-id-user-${item._id}`}
                  checked={checkIds.includes(item._id)}
                  onChange={(e) => onSelected(item._id, e.target.checked)}
                  color='primary'
                />
              )
            }))}
            loading={loading}
            totalRows={list.length}
            skip={0}
            rowsPerPage={list.length}
            columns={[
              {
                label: '#',
                key: 'index',
                align: 'center',
                width: 10,
                show: true,
                hide: false
              },
              {
                show: true,
                key: 'checkIds',
                align: 'center',
                width: 15,
                label: (
                  <Checkbox
                    id={`checkbox-id-user-header`}
                    checked={checkIds.length > 0 && checkIds.length === list.length}
                    indeterminate={checkIds.length > 0 && checkIds.length < list.length}
                    onChange={(e) => onSelectedAll(e.target.checked)}
                    color='primary'
                  />
                )
              },
              {
                label: 'Photo',
                key: 'avatar',
                align: 'center',
                className: 'text-center',
                show: true,
                hide: false,
                width: 15
              },
              {
                label: 'Code',
                hide: true,
                key: 'code',
                show: true,
                delete: true,
                filter: 'text'
              },
              {
                label: 'Name',
                hide: true,
                key: 'fullName',
                show: true,
                delete: true,
                filter: 'text'
              }
            ]}
            labelNoRows="You don't have any students yet"
          />
        )}
      </div>
    </>
  );
};

export default SelectStudentsTable;
